/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import { getNotifications, showModal, markNotificationAsSeen } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { withRouter } from "react-router-dom";

class Notificationsbar extends Component {
  state = {
    notificationsFetched: false,
    seenNotifications: [],
  };

  // unlisten = this.props.history.listen((location, action) => {
  //   if (location.pathname.toLowerCase() !== "/login" && this.props.auth.token) {
  //     this.fetchNotifications();
  //   }
  // });

  fetchNotifications = () => {
    this.props.getNotifications(this.onBegin, this.onSuccess, this.onError);
    // this.unlisten();
  };

  componentDidMount() {
    if (Object.keys(this.props.generalProfile).length !== 0) {
      this.fetchNotifications();
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (!prevProps.auth.token && this.props.auth.token) {
  //     this.fetchNotifications();
  //   }
  // }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      notificationsFetched: true,
    });
  };

  onNotificationSeenBegin = () => { };
  onNotificationSeenSuccess = (id) => {
    let seenNotifications = [...this.state.seenNotifications];
    this.setState({ seenNotifications: [...seenNotifications, id] });
  };
  onNotificationSeenError = () => { };

  showNotificationDetail = (notification) => {
    this.props.showModal({
      modalType: "NotificationDetail",
      modalTitle: notification.subject,
      modalContent: notification.text,
      // modalFooter: action.payload.modalFooter,
    });

    this.props.markNotificationAsSeen(
      notification.id,
      this.onNotificationSeenBegin,
      this.onNotificationSeenSuccess,
      this.onNotificationSeenError
    );
  };

  renderNotificationCount = () => {
    if (this.state.notificationsFetched) {
      if (!this.props.notifications || this.props.notifications.length === 0) {
        return null;
      }
      return (
        <span className="badge badge-pill badge-danger noti-icon-badge">
          {this.props.notifications.length}
        </span>
      );
    }
  };

  renderNotificationList = () => {
    if (this.state.notificationsFetched) {
      if (this.props.notifications?.length !== 0) {
        return (
          <div className="natificationList">
            <div className="natificationTitle">
              <Trans desc="Bildirimler">10175</Trans>
            </div>
            {this.renderData()}
            <a href="#" className="allnatification-link text-center">
              <div className="allnatification-link-title">
                <Trans desc="Tümünü Göster">10012</Trans>
              </div>
            </a>
          </div>
        );
      }
    }

    return null;
  };

  renderData = () => {
    return this.props.notifications.map((n) => {
      return (
        <a
          href="#"
          className="natification-link"
          onClick={() => this.showNotificationDetail(n)}
          key={n.id}
        >
          <div className="natificationPaddingArea">
            <div className="natificationButton">
              <div className="natificationTextArea">
                <div className="natificationIcon">
                  <span className="iconmford fo-icon-live-tv "></span>
                </div>
                <div className="natificationInfo">
                  <div className="natificationBaslik">{n.subject}</div>
                  <div className="natificationDesc">
                    {n.text
                      ? n.text.length > 60
                        ? n.text.substring(0, 61) + "..."
                        : n.text
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      );
    });
  };

  render() {
    if (Object.keys(this.props.generalProfile).length === 0) return null;

    return (
      <>
        <a href="#">
          <span className="iconmford fo-icon-notifications-none"></span>
          {this.renderNotificationCount()}
        </a>
        {this.renderNotificationList()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
    notifications: state.notifications.data.notifications,
    modal: state.modal,
    application: state.application,
  };
};

export default connect(mapStateToProps, {
  getNotifications,
  showModal,
  markNotificationAsSeen,
})(withRouter(containsLongRunningProcess(Notificationsbar)));
